export const GET = {
  REQUEST: 'Phases/Get/Request',
  SUCCESS: 'Phases/Get/Success',
  FAILURE: 'Phases/Get/Failure'
};

export const GET_TYPES = {
  REQUEST: 'PhaseTypes/Get/Request',
  SUCCESS: 'PhaseTypes/Get/Success',
  FAILURE: 'PhaseTypes/Get/Failure'
};
